export const OPEN_SHARE_MODAL = 'OPEN_SHARE_MODAL';
export const CLOSE_SHARE_MODAL = 'CLOSE_SHARE_MODAL';